module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAATxJREFUKBV10i9LQ1EYx/F7RF3TJDOIDMM0+AZEMShiMAgODGabGGTJYDJYZPoGliyWFf80QUFsgmAaw2QQmUUQdSrs+P1ddu4O95498Lnn3/MbZ9s1UaqsteNsLaOAFhq4MMZ8MmaLQA4naOEPr3D1zmQ7k2JToUvcYxGzmMMd/ConYXYHoNAthtwB82O0sYYDfEO1E/cw2YiX1pZcyI3sz2MEeexB9YN8xONKK+rcBdIjZ4dxR/dRVvCls35k7AuE9rv9yayq4FeytLbKfBAGC1jCB9JVU7Du7eqvOEIR+mHeEKqKrnbtXS/HfAsr2EQTobrRlaY5eUB/quOX9Sna0Aeso4AnTCHSdUvQ2xKqyU7PLofPmIhD7sFGKKzXbhVnyIa88AwNNfi/dJN1BWOur+dIk777KIZ7Nf0DJvnINSH+DcMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-website.png
// module id = 1409
// module chunks = 0